













import {Vue,Component,Prop, Watch,Mixins} from 'vue-property-decorator';
import BookmarkMixin from './BookmarkMixin';
import store from '../../../../store';
@Component
export default  class  SenderSignBookmark extends Mixins(BookmarkMixin){
    created(){
        if(this.defaultValue)
            this.value = this.defaultValue;
        else
            this.value = '';
    }
    focusOut(){
        if(this.isMandatory)
            this.$emit("value-changed",this.englishName);
    }
}
